import { Button } from '@mui/material'
import React from 'react'

export default function HaveQuestion() {
  return (
    <div className='havequestion__main'>
      
      <div className='havequestion__upper'>

<h4 >Have a Question?</h4>
<div className='videosection__line'/>
<p>Before you reach out to us, check out our FAQ page.
Good chance your question has already been answered there.</p>

<div className='timing'>

<div className='timming__inner'>
<h4>Monday</h4>
<p> 8am – 11pm </p>
</div>

<div className='timming__inner'>
<h4>Tuesday</h4>
<p> 8am – 11pm </p>
</div>

<div className='timming__inner'>
<h4>Wednesday</h4>
<p> 8am – 11pm </p>
</div>

<div className='timming__inner'>
<h4>Thursday</h4>
<p> 8am – 11pm </p>
</div>

<div className='timming__inner'>
<h4>Friday</h4>
<p> 8am – 6pm </p>
</div>

<div className='timming__inner'>
<h4>Saturday</h4>
<p> 8am – 11pm </p>
</div>

<div className='timming__inner'>
<h4>Sunday</h4>
<p> 8am – 11pm </p>
</div>

</div>

      </div>

    </div>
  )
}
